<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="u-window m-offer-modal">
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <ul v-if="shop_list.length > 0" class="ticket-view">
                    <li v-for="(item,index) in shop_list" :key="index">
                        <div class="status apply" v-if="item.state == 1"></div>
                        <div class="status dismiss" v-if="item.state == 2"></div>
                        <div class="ticket">
                            <p>店铺专用券</p>
                        </div>
                        <div class="ticket-detail">
                            <h6>{{ item.shopName }}</h6>
                            <p>{{ item.shopOfferName }}</p>
                            <p class="time">{{ time }}</p>
                        </div>
                    </li>
                </ul>                
            </div>       
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            shop_list : [],
            time : this.$global.activityTime,
        }
    },
    created (){
        this.$toast('您有以下优惠劵可以使用~');
    },
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },  
    },       
}
</script>

<style scoped>
.ticket-view li {
    display: flex;
    width: 672px;
    height: 162px;
    margin: 0 auto 10px;
    color: #fff;
    align-items: center;
    background-image: url(~@/assets/images/item-ticket.png);
}

.ticket-view .status {
    margin-left: 20px;
}

.ticket-view .status.apply {
    width: 49px;
    height: 49px;
    background-image: url(~@/assets/images/ticke-apply.png);
}

.ticket-view .status.dismiss {
    width: 73px;
    height: 89px;
    background-image: url(~@/assets/images/ticket-dismiss.png);
}

.ticket-view .ticket {
    position: relative;
    width: 211px;
    height: 124px;
    margin: 0 20px;
    background-image: url(~@/assets/images/sale-8.png);
}

.ticket-view .ticket p {
    position: absolute;
    left: 0;
    bottom: 10px;
    padding-left: 55px;
}

.ticket-view .ticket-detail {
    color: #6a2b0f;
}

.ticket-view .ticket-detail h6 {
    font-weight: 700;
    font-size: 28px;
}

.ticket-view .ticket-detail .time {
    color: #b4603b;
}
</style>



// WEBPACK FOOTER //
// src/components/OfferModal/offerModal.vue